import React, { useEffect, useState } from 'react';
import { Box, IconButton, Button, Card, CardContent, CardMedia, Typography, Grid } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import { Edit, Delete, Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import AdminNavbar from '../components/AdminNavbar';
import Sidebar from '../components/Sidebar';
import ApiService from '../../../config/api';

const AllFounders = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [sidebarOpen, setSidebarOpen] = useState(!isSmallScreen);
  const [founders, setFounders] = useState([]);
  const navigate = useNavigate();

  const toggleDrawer = () => setSidebarOpen(!sidebarOpen);

  // ✅ Fetch Founders
  const fetchFounders = async () => {
    try {
      const res = await ApiService.get('user/founders');
      if (!res.data.error) {
        setFounders(res.data.meta);
      }
    } catch (err) {
      console.error('Error fetching founders:', err);
    }
  };

  // ✅ Delete Founder
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this founder?")) return;
    try {
      await ApiService.delete(`admin/remove/${id}`);
      fetchFounders(); // refresh list
    } catch (err) {
      console.error("Error deleting founder:", err);
    }
  };

  useEffect(() => {
    fetchFounders();
  }, []);

  return (
    <Box
      display="grid"
      gridTemplateColumns={sidebarOpen ? "200px 1fr" : "60px 1fr"}
      sx={{
        transition: "grid-template-columns 0.3s ease-in-out",
        backgroundColor: 'var(--bs-secondary)',
        minHeight: '100vh',
      }}
    >
      <Sidebar open={sidebarOpen} toggleDrawer={toggleDrawer} setOpen={setSidebarOpen} />

      <Box>
        <AdminNavbar />

        {/* Header + Add Button */}
        <Box display="flex" justifyContent="space-between" alignItems="center" p={3}>
          <Typography variant="h5" sx={{ color: "var(--bs-primary)" }}>
            Founders
          </Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            sx={{
              backgroundColor: "var(--bs-primary)",
              color: "#fff",
              "&:hover": { backgroundColor: "var(--bs-accent)" },
            }}
            onClick={() => navigate("/admin/create-founder")}
          >
            Add Founder
          </Button>
        </Box>

        {/* Founders Grid */}
        <Grid container spacing={3} px={3} pb={5}>
          {founders.map((founder) => (
            <Grid item xs={12} sm={6} md={4} key={founder._id}>
              <Card
                sx={{
                  borderRadius: "16px",
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                backgroundColor: "var(--bs-primary)" ,
                }}
              >
                {founder.image && (
                  <CardMedia
                    component="img"
                    className='contain'
                    image={founder.image}
                    alt={founder.name}
                    sx={{
                      objectFit: "contain",
                      width: "100%",
                    }}
                  />
                )}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ color: "var(--bs-accent)" }}>
                    {founder.name}
                  </Typography>
                  <Typography variant="body2" color="text.accent" sx={{ color: "var(--bs-secondary)" }}>
                    {founder.description}
                  </Typography>
                </CardContent>

                {/* Edit + Delete Buttons */}
                <Box display="flex" justifyContent="flex-end" p={1}>
                  <IconButton
                    onClick={() => navigate(`/admin/create-founder/${founder._id}`)}
                    sx={{ color: "var(--bs-accent)" }}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDelete(founder._id)}
                    sx={{ color: "var(--bs-accent)" }}
                  >
                    <Delete />
                  </IconButton>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default AllFounders;
